import {
    CLICK_EVENT,
    INPUT_EVENT,
    FREE_TEXT_FILTER_NAME,
    CLICKED_CSS_CLASS,
    HIDE_CSS_CLASS,
} from './constants';

export default class FreeTextFilter {
    constructor({
        elm,
        addToSelectedFilters,
        removeFromSelectedFilters,
        openDropDownCallback,
    }) {
        this.textFilter = elm?.querySelector('[data-text-filter]');
        this.searchSvgClosed =
            this?.textFilter?.querySelector('#text-filter-svg');
        this.searchSvgOpen = this?.textFilter?.querySelector('.circle');
        this.textFilterInputDropdown = elm?.querySelector(
            '[data-text-dropdown]',
        );
        this.textInput = this.textFilterInputDropdown?.querySelector('input');
        this.inputLabel = this.textFilterInputDropdown?.querySelector('label');

        this.removeFromSelectedFilters = removeFromSelectedFilters;
        this.addToSelectedFilters = addToSelectedFilters;
        this.openDropDownCallback = openDropDownCallback;

        this.textFilter?.addEventListener(
            CLICK_EVENT,
            this.toggleFreeText.bind(this),
        );

        this.textInput?.addEventListener(
            INPUT_EVENT,
            this.updateFreeTextInput.bind(this),
        );
    }

    dropDownIsOpen() {
        return this.textFilterInputDropdown.classList.contains('clicked');
    }

    removeHasValueClass() {
        this.inputLabel.classList.remove('has-value');
    }

    updateFreeTextInput() {
        const { value, id } = this.textInput;
        this.removeFromSelectedFilters({
            id,
            filterName: FREE_TEXT_FILTER_NAME,
            updateBadge: false,
            clearInputValue: false,
        });
        if (value) {
            this.inputLabel.classList.add('has-value');
            if (value.length > 2) {
                this.textInput.value = value; // the removeFromSelectedFilter can have a race condition...
                const customSpan = document.createElement('span');
                const innerSpan = document.createElement('span');
                innerSpan.classList.add('text--bold');
                innerSpan.classList.add('text--italic');
                innerSpan.innerText = value;
                customSpan.innerText = 'Fritekst: ';
                customSpan.append(innerSpan);
                this.addToSelectedFilters({
                    inputNode: this.textInput,
                    customSpan,
                    removeKeywordCallback: this.removeHasValueClass.bind(this),
                });
            }
        } else {
            this.removeHasValueClass();
        }
    }

    clearInputValue() {
        this.textInput.value = '';
    }

    resetFreeText() {
        this.clearInputValue();
        this.removeFromSelectedFilters({
            id: this.textInput.id,
            filterName: FREE_TEXT_FILTER_NAME,
            updateBadge: false,
        });
    }

    openDropDown() {
        this.textFilterInputDropdown?.classList.add(CLICKED_CSS_CLASS);
        this.searchSvgOpen?.classList.remove(HIDE_CSS_CLASS);
        this.searchSvgClosed?.classList.add(HIDE_CSS_CLASS);
        this.openDropDownCallback();
    }

    closeDropDown() {
        this.textFilterInputDropdown?.classList.remove(CLICKED_CSS_CLASS);
        this.searchSvgClosed?.classList.remove(HIDE_CSS_CLASS);
        this.searchSvgOpen?.classList.add(HIDE_CSS_CLASS);
        this.resetFreeText();
    }

    toggleFreeText() {
        this.dropDownIsOpen() ? this.closeDropDown() : this.openDropDown();
    }
}
